import React, {  Fragment } from "react";
import { Carousel } from "antd";
import "./index.less";

import banner1 from "@/assets/img/home-page/home-banner1.png";
import banner2 from "@/assets/img/home-page/home-banner2.png";
import banner3 from "@/assets/img/home-page/home-banner3.png";
import banner4 from "@/assets/img/home-page/home-banner4.png";

import h5Banner1 from "@/assets/img/home-page/h5-home-banner1.png";
import h5Banner2 from "@/assets/img/home-page/h5-home-banner2.png";
import h5Banner3 from "@/assets/img/home-page/h5-home-banner3.png";
import h5Banner4 from "@/assets/img/home-page/h5-home-banner4.png";

import product1 from "@/assets/img/home-page/product1.png";
import product2 from "@/assets/img/home-page/product2.png";
import product3 from "@/assets/img/home-page/product3.png";
import product4 from "@/assets/img/home-page/product4.png";

import ProductListCom from './component/ProductList';
import MainBusiness from './component/MainBusiness';
import CooperativePartner from './component/CooperativePartner';
import { isMobile } from '@/utils/utils';

function Home() {
  const bannerData = [
    { imgBg: isMobile() ? h5Banner1 : banner1, title: '企 业 征 信', subTitle: '基于互联网+物联网数据', subTitle1: '依托企业征信牌照，提供场景化企业征信服务' },
    { imgBg: isMobile() ? h5Banner2 : banner2, title: '融 资 便 利', subTitle: '构建企业画像', subTitle1: '深度挖掘价值客户，实现精准信贷服务' },
    { imgBg: isMobile() ? h5Banner3 : banner3, title: '数 据 服 务', subTitle: '多元化数据融合', subTitle1: '为企业和银行数字化转型，提供智能决策服务' },
    { imgBg: isMobile() ? h5Banner4 : banner4, title: '信 用 报 告', subTitle: '结合产业和业务场景', subTitle1: '创建信用管理模型，提供多元化资信报告' },
  ]
  const productData = [
    { img: product1, title: '智能小工具', title1: '客户经理的智能移动尽调平台', content: '基于中小银行的科技基础能力，结合自身数字产业金融实践，锦誉征信独创的面向银行客户经理的智能移动尽调平台，助力银行开展数字普惠金融业务，服务下沉客群，内置PBOC模型、资金流水分析、负债分析和三方数据解析等标准模块，大幅增强机构或使用者的数字化风控能力和展业效率' },
    { img: product2, title: '现金流尽调分析平台', title1: '提升展业效率，为信贷决策提供依据', content: '智能识别主流银行、微信、支付宝电子流水格式，自动完成多银行流水数据的识别、清洗和汇总处理，通过数据结构、余额校验、核心字段及数据分布等多规则判断数据真伪，智能分析企业资金全貌' },
    { img: product3, title: '信用评估报告', title1: '打造智能化金融风控体系', content: '通过大数据的快速更新、整合、分析和风险预警，实现对企业信贷风险的传导和追踪数字化的贷后监测和预警模型，掌握更及时可靠的企业经营情况' },
    { img: product4, title: '精准信贷服务', title1: '全面助力中小微企业发展', content: '聚焦产业金融场景，通过企业画像挖掘价值客户，利用物联网、大数据、人工智能等新一代技术，链接中小微企业和金融机构，促进金融业务发展，推动中小微企业融资模式转型升级' },
  ]
  return (
    <Fragment>
      <div className="home-page">
        <section>
          <div className="home-page-header">
            <Carousel autoplay={true}>
              {
                bannerData.map((item, index) => (
                  <div key={`banner-${index+1}`}>
                    <div
                      className="banner-item"
                      style={{ backgroundImage: `url(${item.imgBg})` }}
                    >
                      <div>
                        <div className="banner-title">{item.title}</div>
                        <div className="banner-subtitle">{item.subTitle}</div>
                        <div className="banner-subtitle1">{item.subTitle1}</div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </Carousel>
          </div>
        </section>
        <section className="main-business-box">
          <MainBusiness />
        </section>
        <section className="product-warp">
          <ProductListCom productData={productData} />
        </section>
        <section className="cooperative-partner-warp">
          <CooperativePartner />
        </section>
      </div>
    </Fragment>
  );
}

export default Home;
